interface MappingResponse {
  mappings: Record<string, string>;
  characterSet: string;
}

let mappings: Record<string,string> | null = null;
let characterSet: string | null = null;

export async function loadMappings(): Promise<void> {
  if (mappings) return;

  const res = await fetch("dynamic/mappings.json", { cache: 'no-cache' });

  if (res.status === 304) {
    // nothing changed; leave mappings as-is
    return;
  }
  if (!res.ok) {
    throw new Error(`Failed to load mappings: ${res.status}`);
  }

  const response: MappingResponse = await res.json();
  mappings = response.mappings;
  characterSet = response.characterSet;
}

export function getMappings(): Record<string,string> {
  if (!mappings) {
    throw new Error("Mappings not loaded — call loadMappings() first");
  }
  return mappings;
}

export function getCharacterSet(): string {
  if (!characterSet) {
    throw new Error("Character set not loaded — call loadMappings() first");
  }
  return characterSet;
}
